import { FC } from "react";
import { Box, Fab, Theme, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { AIIcon } from "@/assets/icons/app-related/AIIcon";

interface AskAiFloatingButtonProps {
  onClick(): void;
}

export const AskAiFloatingButton: FC<AskAiFloatingButtonProps> = ({
  onClick,
}) => {
  return (
    <Box
      zIndex={(theme: Theme) => theme.zIndex.drawer}
      right={32}
      bottom={32}
      position="fixed"
    >
      <Stack
        alignItems="center"
        position="absolute"
        bgcolor="white"
        py={0.2}
        px={0.5}
        top={-8}
        right={-12}
        borderRadius={2}
        zIndex={(theme: Theme) => theme.zIndex.drawer}
        border={1}
        borderColor="primary.main"
      >
        <Typography
          variant="caption"
          color="primary.main"
          fontWeight="bold"
          lineHeight={1.2}
        >
          beta
        </Typography>
      </Stack>

      <Fab
        sx={{
          background: "linear-gradient(100deg, #1443EA, #7334F1)",
          height: 48,
          width: 48,
        }}
        onClick={onClick}
      >
        <AIIcon color="white" />
      </Fab>
    </Box>
  );
};
